var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Navbar"}},[_c('div',{staticClass:"flex flex1"}),_c('div',[_c('div',{staticClass:"tac"},[_c('el-button',{attrs:{"type":"danger"},on:{"click":_vm.logout}},[_vm._v("Exit")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }